export default __webpack_public_path__ + "static/media/bg-footer-top-mobile.c940267b.svg";